import { Autocomplete } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { useCallback, useState } from 'react';
import { _MUNICIPAL_MESSENGER_TOPONYMY_LIST_API_URL } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { FormikProps } from 'formik';
import { MunicipalMessengerTransformedForm } from 'municipal-messenger/view-models/municipal-messenger-form';
import { NewToponymyTransformedForm } from 'municipal-messenger/view-models/new-toponymy-form';

interface NewLocalAreaProps {
  disabled?: boolean;
  required?: boolean;
  label?: string;
  value: string;
  onChange: (values: string) => void;
  form?: FormikProps<MunicipalMessengerTransformedForm> | FormikProps<NewToponymyTransformedForm>;
}

const LocalAreaToponymy = ({
  value,
  onChange,
  form,
  disabled = false,
  required = false,
  label = 'Ambito Territoriale',
}: NewLocalAreaProps): React.ReactElement => {
  const handleField = useCallback(
    (newValue: string) => {
      onChange(newValue);
    },
    [onChange]
  );

  const [localAreaFilter, setLocalAreaFilter] = useState('');
  const [defaultLocalAreaList, setDefaultLocalAreaList] = useState<string[]>([]);
  const [localAreaListData, setLocalAreaListData] = useState<string[]>([]);

  const [localArea] = useHttpFetch<HttpResponse<string[]>, string[]>(
    `${_MUNICIPAL_MESSENGER_TOPONYMY_LIST_API_URL}/ambiti`,
    {
      onBootstrap: true,
      transformer: (response) => {
        setLocalAreaListData(response?.data?.payload);
        setDefaultLocalAreaList(response?.data?.payload);
        return response?.data?.payload;
      },
    }
  );

  const handleLocalAreaChange = useCallback(
    (filterValue: string) => {
      if (localArea.abort) {
        localArea.abort();
      }
      setLocalAreaFilter(filterValue);
      setLocalAreaListData(
        filterValue.length
          ? defaultLocalAreaList.filter((e) => e.startsWith(filterValue))
          : defaultLocalAreaList
      );
    },
    [localArea]
  );

  return (
    <Autocomplete
      options={localAreaListData || []}
      getOptionLabel={(option: string) => option}
      disableClearable
      disabled={disabled}
      value={value || ''}
      onChange={(event, newValue: string) => {
        handleField(newValue);
      }}
      noOptionsText="Nessun elemento"
      loadingText="Caricamento..."
      renderInput={(params) => (
        <PmiTextField
          {...params}
          id="localArea"
          name="localArea"
          fullWidth
          onBlur={form?.handleBlur}
          label={required ? `${label} *` : label}
          helperText={form?.errors?.localArea}
          value={localAreaFilter}
          onChange={(event) => {
            handleLocalAreaChange(event.target.value);
          }}
          error={form?.touched?.localArea && Boolean(form?.errors?.localArea)}
        />
      )}
    />
  );
};

LocalAreaToponymy.displayName = 'local area autocomplete component';

export default LocalAreaToponymy;
